module.exports = __webpack_public_path__ + "img/zhanjia1.d914813f.jpeg";